import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Modifier } from '@teem/app/core/model-forms/modifier-model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModifierService {
    private apiUrl = '/api/v1/modifiers';

    constructor(private http: HttpClient) {}

    getModifiers(): Observable<Modifier[]> {
    return this.http.get<Modifier[]>(this.apiUrl); // includes options array
    }

    addModifier(modifier: Modifier): Observable<Modifier> {
    return this.http.post<Modifier>(this.apiUrl, modifier);
    }

    updateModifier(modifier: Modifier): Observable<Modifier> {
    return this.http.put<Modifier>(`${this.apiUrl}/${modifier.id}`, modifier);
    }

    deleteModifier(id: number): Observable<void> {
        return this.http.delete<void>(`${this.apiUrl}/${id}`);
    }
}
